import { t } from "@lingui/macro";
import { Message } from "../../models/Message";
import { Notification, NotificationType } from "../../models/Notification";
import { Util } from "./Util";
import { UtilApp } from "./UtilApp";


//notification
export class NotificationUtil {

  static createForMessage(msg: Message, toUserId: string): Notification {
    let type: NotificationType = 'Info';
    if (msg.recording) {
      type = 'Voice';
    } else if (msg.videoUrl) {
      type = 'VideoRecording';
    } else if (msg.emoticon) {
      type = 'Emoticon';
    } else if (!!msg.files?.find(f => f.group == 'image')) {
      type = 'Images';
    } else if (!!msg.files?.find(f => f.group == 'doc')) {
      type = 'Docs';
    } else if (msg.text) {
      type = 'Text';
    } else if (msg.emoji) {
      type = 'Emoji';
    }
    return new Notification(type, toUserId, msg.roomId, null, msg.id, msg.parentMessageId, msg.replyToMessageId, msg.user);
  }

  static getSummaryTranslated(notif: Notification): string {
    const mentionEnding = ' ' + (notif.isMentioned ? t`and mentioned you` : '');
    if (notif.type == 'Voice') {
      return t`${notif.fromUser?.name} recorded a new message`;
    } else if (notif.type == 'Text') {
      if (notif.subtitle)
        return notif.subtitle;
      else
        return notif.isMentioned ? t`${notif.fromUser?.name} mentioned you` : t`${notif.fromUser?.name} wrote a message`;
    } else if (notif.type == 'VideoRecording') {
      return t`${notif.fromUser?.name} posted a video` + mentionEnding;
    } else if (notif.type == 'Emoticon') {
      return t`${notif.fromUser?.name} left a reaction`;
    } else if (notif.type == 'Emoji') {
      return t`${notif.fromUser?.name} left an emoji`;
    } else if (notif.type == 'Images') {
      return t`${notif.fromUser?.name} shared images` + mentionEnding;
    } else if (notif.type == 'Docs') {
      return t`${notif.fromUser?.name} shared documents` + mentionEnding;
    } else if (notif.type == 'RoomAdded') {
      return t`${notif.fromUser?.name} added you to ${notif.roomName}`;
    } else if (notif.type == 'CallStart') {
      if (Util.isOneToOneRoom(notif.roomName)) {
        return t`${notif.fromUser?.name} requested a voice call`;
      } else {
        return t`${notif.fromUser?.name} started a call in ${notif.roomName}`;
      }
    } else {
      return t`${notif.fromUser?.name} posted something` + mentionEnding;
    }
  }

}
